import { motion } from 'framer-motion';
import Card from '../Card';
import Label from '../Label';
import AccessOption, { AccessOptionsProps } from './access-option';
import PeopleWithAccessTable, { PeopleProps } from './access-people-table';

export type ManageAccessProps = AccessOptionsProps & {
    container?: HTMLElement | ShadowRoot | null,
    people: PeopleProps[],
    onDelete: (id: string | number, role: string) => void,
    onResendInvite: (id: string | number) => void,
}
const MotionCard = motion(Card);
const ManageAccess = ({ accessOptions, handleAccessLevelChange, accessLevel, people, onDelete, onResendInvite, container }: ManageAccessProps) => {
    return (
        <MotionCard
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="mt-4 border-none shadow-none">
            <Card.Content className="flex flex-col gap-2 w-full space-y-4 p-0">
                <div className='text-sm'>
                    Control who can access this project and update access permissions as needed.
                </div>
                <div>
                    <Label>General Access</Label>
                    <AccessOption
                        accessLevel={accessLevel}
                        handleAccessLevelChange={handleAccessLevelChange}
                        accessOptions={accessOptions}
                    />

                </div>
                <div className='flex flex-col gap-0.5'>
                    <Label>People with Access</Label>
                    <PeopleWithAccessTable
                        people={people}
                        onDelete={onDelete}
                        onResendInvite={onResendInvite}
                        container={container}
                    />
                </div>
            </Card.Content>
        </MotionCard>
    );
};

export default ManageAccess;
